import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { dataService } from '../../Services/data.service';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { toast } from 'react-toastify';
import BackForwardButton from '../Shared/BackForwardButton';
import QualityCheckStepContent from './QualityCheckStepContent.jsx';
import { useTranslation } from 'react-i18next';


export default function NewQualityCheckDrawer(props) {
    const classes = useStyles();
    const [qualityCheckSteps, setQualityCheckSteps] = useState([])
    const [qualityCheckStepList, setQualityCheckStepList] = useState([])
    const [dataFetched, setDataFetched] = useState(false)
    const [currentStep, setCurrentStep] = useState(1)
    const [newQualityCheck, setNewQualityCheck] = useState([])

    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true
        dataService.getQualityCheckSteps().then(steps => {
            if (mounted) {
                if (qualityCheckSteps.length !== steps.body.length) {
                    setQualityCheckSteps(steps.body)
                    updateQualityCheckStepList(steps.body, currentStep)
                }
                setDataFetched(true)
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        return function cleanup() {
            mounted = false
        }
    }, [qualityCheckSteps, currentStep]);

    function updateQualityCheckStepList(steps, currentStep) {
        let stepList = Object.assign([], steps);
        steps.forEach(x => {
            let index = steps.indexOf(x, 0)
            if (x.id < currentStep) {
                stepList[index]["checked"] = true
                stepList[index]["active"] = false
                stepList[index]["todo"] = false
            }
            else if (x.id === currentStep) {
                stepList[index]["checked"] = false
                stepList[index]["active"] = true
                stepList[index]["todo"] = false
            }
            else if (x.id > currentStep) {
                stepList[index]["checked"] = false
                stepList[index]["active"] = false
                stepList[index]["todo"] = true
            }
        })
        setQualityCheckStepList(stepList)
    }

    function nextStep() {
        if (currentStep < qualityCheckSteps.length + 1) {
            let nextStep = currentStep + 1
            setCurrentStep(nextStep)
            updateQualityCheckStepList(qualityCheckSteps, nextStep)
        }
    }

    function previousStep() {
        if (currentStep > 1) {
            let previousStep = currentStep - 1
            setCurrentStep(previousStep)
            updateQualityCheckStepList(qualityCheckSteps, previousStep)
        }
    }  

    function saveStep(stepDetails, stepId) {
        let stepName = qualityCheckSteps.find(x => x.id === stepId).name
        let tempNewQualityCheck = Object.assign([], newQualityCheck);
        if (tempNewQualityCheck.some(x => x.stepId === stepId)) {
            tempNewQualityCheck.find(x => x.stepId === stepId).details = stepDetails
            setNewQualityCheck(tempNewQualityCheck)
        }
        else {
            tempNewQualityCheck.push({ stepId: stepId, step: stepName, details: stepDetails })
            setNewQualityCheck(tempNewQualityCheck)
        }

        if (stepId === qualityCheckSteps.length) {
            saveNewQualityCheck(tempNewQualityCheck)
            props.openDrawer(false)
        }
        else {
            nextStep()
        }
    }

    function saveNewQualityCheck(tempNewQualityCheck) {
        props.openDrawer(false)
    }

    let stepContent = <React.Fragment></React.Fragment>
    if (dataFetched) {
        qualityCheckSteps.forEach(x => {
            if (x.id === currentStep) {
                let index = qualityCheckSteps.indexOf(x, 0)
                let buttonText = ""
                if (index === qualityCheckSteps.length - 1) {
                    buttonText = t("CREATE NEW QUALITY CHECK")
                }
                else {
                    buttonText = t("NEXT") +": " + t(qualityCheckSteps[index + 1].name.toUpperCase());
                }
                stepContent = <QualityCheckStepContent key={x.id} details={x.details} buttonText={buttonText} saveStep={saveStep} stepId={x.id} savedContent={newQualityCheck}></QualityCheckStepContent>
            }
        })
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.stepperBar}>
                <div className={classes.title}>{t("New quality check")}</div>
                <div>
                    <List>
                        {dataFetched ? qualityCheckStepList.map(x => (
                            <ListItem key={x.id} className={clsx({ [classes.activeListItem]: x.active, [classes.checkedListItem]: x.checked, [classes.todoListItem]: x.todo })}>
                                {x.checked ? <img className={classes.check} alt="greenCheck" src={process.env.PUBLIC_URL + '/img/greenCheck.svg'}></img> : <React.Fragment></React.Fragment>}
                                <div className={clsx({ [classes.activeStep]: x.active, [classes.checkedStep]: x.checked, [classes.todoStep]: x.todo })}>{x.id + ". " + t(x.name)}</div>
                            </ListItem>
                        )
                        ) : <React.Fragment></React.Fragment>}
                    </List>                  
                </div>
            </div>
            <div className={classes.main}>
                <div className={classes.header}>
                    <button className={classes.previousButton} onClick={previousStep}><BackForwardButton textOverride={t("previous")} direction={"back"}></BackForwardButton></button>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
                <div className={classes.stepContent}>
                    {stepContent}
                </div>
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles((theme) => ({

    drawerBody: {
        width: "100%",
        height: "100%"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    header: {
        display: 'block',
        width: "100%",
        height: "50px",
        paddingTop: "10px"
    },
    stepContent: {
        display: 'block'
    },
    drawerOpen: {
        width: "60%",
        paddingRight: "20px",
    },
    drawerClose: {
        width: 0
    },
    stepperBar: {
        width: "280px",
        backgroundColor: "#EFEFEF",
        height: "100%",
        float: "left",
        paddingLeft: "20px",
        paddingTop: "20px",
        boxSizing: 'border-box'
    },
    title: {
        marginBottom: "20px",
        color: '#020100',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'regular',
    },
    main: {
        width: "calc(100% - 280px)",
        backgroundColor: "white",
        float: "left",
        height: "100%",
        paddingLeft: "15px",
        boxSizing: "border-box"
    },
    activeStep: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "white",
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    checkedStep: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'regular',
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    todoStep: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'regular',
        paddingTop: "5px",
        paddingBottom: "5px",
    },
    activeListItem: {
        backgroundColor: "white",
        paddingLeft: "8px !important",
        borderRadius: "6px 0 0 6px"
    },
    checkedListItem: {
        paddingLeft: "8px !important"
    },
    todoListItem: {
        paddingLeft: "8px !important"
    },
    previousButton: {
        backgroundColor: "white",
        border: "none"
    },
    check:{
        marginRight:"5px"
    }
}));